var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.actualizando)?_c('apex-chart',{attrs:{"width":"100%","height":"100%","series":_vm.series,"options":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }